export default __webpack_public_path__ + "static/media/bootstrap-5-1.98585727.svg";